import { render, staticRenderFns } from "./cosmeticsDetail.vue?vue&type=template&id=e4f69a58&scoped=true&"
import script from "./cosmeticsDetail.vue?vue&type=script&lang=js&"
export * from "./cosmeticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./cosmeticsDetail.vue?vue&type=style&index=0&id=e4f69a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f69a58",
  null
  
)

export default component.exports